module.exports = __webpack_public_path__ + "static/media/2playerRoomsPlayed_10000_25000.6e42c7b7.png";